'use strict';

const _=require('pulsar-utils/dist-es6/_');
const it=require('pulsar-utils/dist-es6/it');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const _millisecondsPer={
seconds:timespan.fromSeconds(1).totalMilliseconds(),
minutes:timespan.fromMinutes(1).totalMilliseconds(),
hours:timespan.fromHours(1).totalMilliseconds(),
days:timespan.fromDays(1).totalMilliseconds(),
weeks:timespan.fromDays(7).totalMilliseconds(),
months:timespan.fromDays(30.42).totalMilliseconds(),
years:timespan.fromDays(365).totalMilliseconds()};


const DefaultScales=[{
interval:'seconds',
steps:[1,5,15,30]},
{
interval:'minutes',
steps:[1,5,15,30]},
{
interval:'hours',
steps:[1,3,6,12]},
{
interval:'days',
steps:[1,2]},
{
interval:'weeks',
steps:[1]},
{
interval:'months',
steps:[1,3]},
{
interval:'years',
steps:[1]}];


function _buildIncrements(scales){
return _.flatten(scales.map(s=>s.steps.map(step=>{
const millisecondsPerInterval=_millisecondsPer[s.interval];
if(!_.exists(millisecondsPerInterval)){
throw new Error(`Unexpected 'interval': ${s.interval}`);
}

return{
interval:s.interval,
step:step,
millisecondsPer:millisecondsPerInterval*step};

})));
}

function _formatForReturn(minor,major){
return{
minor:_.omit(minor,'millisecondsPer'),
major:_.omit(major,'millisecondsPer')};

}let

TickIncrementCalculator=class TickIncrementCalculator{
constructor(scales=DefaultScales){
this._increments=_buildIncrements(scales);
}

calculate(duration,idealMinorTicks){
const totalMilliseconds=duration.totalMilliseconds();

const withEstimatedNumTicks=[];
for(const pair of it(this._increments).byPairs()){
withEstimatedNumTicks.push({estimatedNumTics:totalMilliseconds/pair[0].millisecondsPer,pair});
}

const sortedByClosenessToIdeal=_(withEstimatedNumTicks).sortBy(o=>Math.abs(idealMinorTicks-o.estimatedNumTics)).value();
const withCramptedOnesFilteredOut=sortedByClosenessToIdeal.filter(o=>o.estimatedNumTics<=idealMinorTicks);

const closestPair=(withCramptedOnesFilteredOut[0]||sortedByClosenessToIdeal[0]).pair;

return _formatForReturn(closestPair[0],closestPair[1]);
}};


module.exports=TickIncrementCalculator;
module.exports.DefaultScales=DefaultScales;
//# sourceMappingURL=tickIncrementCalculator.js.map
